/**
 * API Configuration
 * 환경변수에서 API Base URL을 가져와 중앙에서 관리합니다.
 *
 * Priority:
 * 1. Runtime environment (window.ENV) - injected by Docker entrypoint
 * 2. Build-time environment (process.env)
 * 3. Default fallback - all environments use port 7000
 */

import { environment } from '../../config/environment';

// Extend Window interface for TypeScript
declare global {
  interface Window {
    ENV?: {
      REACT_APP_API_BASE_URL?: string;
      REACT_APP_WEBVIEW_URL?: string;
    };
  }
}

// Use centralized environment configuration
const API_BASE_URL = environment.API_BASE_URL;

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  VERSION: 'v0.1',

  // Full API URL
  get API_URL() {
    return `${this.BASE_URL}/${this.VERSION}`;
  },

  // Endpoints
  ENDPOINTS: {
    // Map Editor Projects
    MAP_EDITOR: {
      PROJECTS: '/map-editor/projects',
      PROJECT_BY_ID: (id: number) => `/map-editor/projects/${id}`,
    },

    // Map Data
    MAP_DATA: {
      PROJECT_DATA: '/map-data/project-data',
      PROJECT_DATA_BY_ID: (projectId: number) => `/map-data/project-data/${projectId}`,
    },

    // Layer Mapping (Optimized - 99.8% DB row reduction)
    LAYER_MAPPING: {
      OBJECT_TYPES: (projectId: number) => `/projects/${projectId}/object-types`,
      OBJECT_TYPE_BY_ID: (projectId: number, id: number) => `/projects/${projectId}/object-types/${id}`,
      // New optimized API - layer-type-mappings (레이어 단위 매핑)
      LAYER_TYPE_MAPPINGS: (projectId: number, floorId: string) => `/projects/${projectId}/floors/${floorId}/layer-type-mappings`,
      LAYER_TYPE_MAPPING_STATS: (projectId: number, floorId: string) => `/projects/${projectId}/floors/${floorId}/layer-type-mappings/stats`,
      LAYER_TYPE_MAPPING_ENTITY_COUNT: (projectId: number, floorId: string, layerName: string) =>
        `/projects/${projectId}/floors/${floorId}/layer-type-mappings/${layerName}/entity-count`,
    },
  },

  // Request timeout (ms) — 대형 맵 CCTV/구역 매핑 저장이 10분을 넘길 수 있어 20분으로 상향
  TIMEOUT: 1200000,

  // Retry configuration
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000,
  },
} as const;

export default API_CONFIG;
